module.exports = __webpack_public_path__ + "img/btn.4cf7f2a8.png";